import { createSelector } from 'reselect';

import { setDefaultSource } from '@src/utils/helpers/costcenter';
import { getFilterCountries } from '@src/utils/globalSelectors';

const getCostCenterSelector = state => state.common.costcenter;
const getCountrySelector = state => state.common.country;

const getCCAndCountryProps = (costcenter, country, countries) => setDefaultSource(country, costcenter, countries);

export const getCCAndCountry = createSelector(
  getCostCenterSelector,
  getCountrySelector,
  getFilterCountries,
  getCCAndCountryProps
);

const getDynamicFilterData = state => state.common.dynamicFilters;

const getRestrictionFilterSelector = dynamicFilters => {
  const restrictions = [];

  if (dynamicFilters && dynamicFilters.length > 0) {
    dynamicFilters.forEach(item => {
      if (item.value.length <= 0) return;

      restrictions.push({
        typeId: item.typeId,
        values: item.value.map(val => val.value),
        title: item.title,
      });
    });
  }

  return restrictions;
};

export const getRestrictionFilter = createSelector(
  getDynamicFilterData,
  getRestrictionFilterSelector
);



// WEBPACK FOOTER //
// ./src/features/yellowfin/selector.js